import React from 'react';

interface CompanyBankingInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyBankingInfo: React.FC<CompanyBankingInfoProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Banking Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="bank_name">Bank Name</label>
          <input
            type="text"
            id="bank_name"
            name="bank_name"
            value={formData.bank_name}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="bank_account">Account Number</label>
          <input
            type="text"
            id="bank_account"
            name="bank_account"
            value={formData.bank_account}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="bank_iban">IBAN</label>
          <input
            type="text"
            id="bank_iban"
            name="bank_iban"
            value={formData.bank_iban}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="bank_bic">BIC/SWIFT</label>
          <input
            type="text"
            id="bank_bic"
            name="bank_bic"
            value={formData.bank_bic}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="bank_sort_code">Sort Code (UK)</label>
          <input
            type="text"
            id="bank_sort_code"
            name="bank_sort_code"
            value={formData.bank_sort_code}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
};